module.exports = __webpack_public_path__ + "static/media/home-hero.e3710287.png";